/**
 * The review domain's API handle. `resolve`, `bulk-resolve`, `sweep`, the queue
 * list, the document detail and the category list all live on the shared,
 * session-aware data layer in {@link module:api/resources}. This module is a
 * thin hook that hands the screens that `review` slice, so every call runs
 * through the ONE app client (bearer token + 401-to-/login).
 */
import { useSession } from '../../auth/session';
import type { QueueQuery, ReviewApi } from '../../api/resources';

export type { QueueQuery, ReviewApi };

/** The review API bound to the current session. */
export function useReviewApi(): ReviewApi {
  return useSession().api.review;
}
